import React, { useState, useEffect, useRef } from 'react';
import './StatsCounter.css';

function StatsCounter() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    fetchStats();
  }, []);

  useEffect(() => {
    if (stats.length === 0 || hasAnimated) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, [stats.length, hasAnimated]);

  const fetchStats = async () => {
    try {
      const response = await fetch('/api/stats');
      const data = await response.json();
      // Ensure data is always an array
      setStats(Array.isArray(data) ? data : []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stats:', error);
      setStats([]);
      setLoading(false);
    }
  };

  const animateCounters = () => {
    stats.forEach((stat, index) => {
      const element = document.getElementById(`counter-${index}`);
      if (!element) return;

      const target = stat.value;
      const duration = 2000; // 2 seconds
      const increment = target / (duration / 16); // 60fps
      let current = 0;

      const updateCounter = () => {
        current += increment;
        if (current < target) {
          element.textContent = Math.floor(current).toLocaleString();
          requestAnimationFrame(updateCounter);
        } else {
          element.textContent = target.toLocaleString();
        }
      };

      setTimeout(() => updateCounter(), index * 200); // Stagger animation
    });
  };

  if (loading) {
    return null;
  }

  if (stats.length === 0) {
    return null;
  }

  return (
    <section className="stats-counter" ref={statsRef}>
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={stat.id} className="stat-item">
              <div className="stat-icon">
                <i className={stat.icon}></i>
              </div>
              <div className="stat-number" id={`counter-${index}`}>
                0
              </div>
              <div className="stat-label">{stat.label}</div>
              {stat.description && (
                <div className="stat-description">{stat.description}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StatsCounter;
